$(document).ready(function() {

    $('.multiple-items').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('#variant_single_product').change(function(e) {
        e.preventDefault();

        var price = $('#variant_single_product option:selected').data('price');
        var weight = $('#variant_single_product option:selected').data('weight');
        $('#current_price').data('base', price);

        $('#weight_single_product').text(weight);
        updatePriceSigleProduct();
        return false;
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    $('a[data-toggle="modal"]').click(function() {
        $('.modal').modal('hide');

        return true;
    });

    $('input.option-color').change(function(e) {
        var instance = $(this);
        $('.item.colors').find('.radio').removeClass('selected');
        instance.closest('.radio').addClass('selected');

        instance.addClass('idle');
        var urlCallback = !!instance.data('url') ? instance.data('url') : '/ajax-callback';

        $.ajax({
            url: urlCallback,
            type: 'POST',
            data: instance.data(),
            success: function (json) {
                instance.prop('disabled', false);

                instance.removeClass('idle');

                if (json.result != 'ok') {
                    if (json.message)
                        show_error(json.message);

                    return;
                }

                if (json.action)
                    eval(json.action);

                if (json.message)
                    show_ok(json.title, json.message, json.redirect);
                else if (json.redirect)
                    location.href = json.redirect;
                else if (json.redirect == "")
                    location.reload();
            }
        });


        /*var basePrice = parseFloat($('#current_price').data('base'));
        var price = basePrice + parseFloat(instance.data('price'));
        $('#current_price').text(price);*/

        return true;
    });

    $(".fancy").fancybox();

    $('.option-price').change(function(e) {
        updatePriceSigleProduct();

        return true;
    });

    $('.incr-btn').click(function(e) {
        var instance = $(this).closest('.qnt-count').find('.quantity');

        instance.addClass('idle');
        var urlCallback = !!instance.data('url') ? instance.data('url') : '/ajax-callback';

        var dataSend = instance.data();
        dataSend.amount = instance.val();

        $.ajax({
            url: urlCallback,
            type: 'POST',
            data: dataSend,
            success: function (json) {
                instance.prop('disabled', false);

                instance.removeClass('idle');

                if (json.result != 'ok') {
                    if (json.message)
                        show_error(json.message);

                    return;
                }

                if (json.action)
                    eval(json.action);

                if (json.message)
                    show_ok(json.title, json.message, json.redirect);
                else if (json.redirect)
                    location.href = json.redirect;
                else if (json.redirect == "")
                    location.reload();
            }
        });
    });

    $('select.js-address-order').change(function() {
        updateAddressOrder();
    });

    updateAddressOrder();
});

function updatePriceSigleProduct() {
    var basePrice = parseFloat($('#current_price').data('base'));

    var allPrice = basePrice;
    $('.option-price:checked').each(function(index, element) {
        allPrice = allPrice + parseFloat($(element).data('price'));
    });

    $('#current_price').text(allPrice);
}

function updateAddressOrder() {
    var fio = $('select.js-address-order').find(":selected").data('fio');
    var phone = $('select.js-address-order').find   (":selected").data('phone');

    $('#checkout-form').find('input[name=phone]').val(phone);
    $('#checkout-form').find('input[name=fio]').val(fio);

}

function updateCartHedaer() {
    var instance = $('#wrap_header_cart');

    instance.addClass('idle');
    var urlCallback = !!instance.data('url') ? instance.data('url') : '/ajax-callback';

    $.ajax({
        url: urlCallback,
        type: 'POST',
        data: instance.data(),
        success: function (json) {
            instance.prop('disabled', false);

            instance.removeClass('idle');

            if (json.result != 'ok') {
                if (json.message)
                    show_error(json.message);

                return;
            }

            if (json.action)
                eval(json.action);

            if (json.message)
                show_ok(json.title, json.message, json.redirect);
            else if (json.redirect)
                location.href = json.redirect;
            else if (json.redirect == "")
                location.reload();
        }
    });

    return true;
}
